export function productHasPrice(product: {
  price?: number | null;
  variants?: { price?: number | null }[] | null;
}): boolean {
  if (product.price != null && product.price > 0) {
    return true;
  }
  return product.variants?.some((variant) => variant.price != null && variant.price > 0) ?? false;
}

export function meetingRequiresAuthentication(product: {
  meeting?: { requireAuthentication?: boolean | null } | null;
  price?: number | null;
  variants?: { price?: number | null }[] | null;
}): boolean {
  return product.meeting?.requireAuthentication === true || productHasPrice(product);
}
